import { useState } from "react";
import { Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import { useT } from "../lib/i18n";
import { streamPost } from "../lib/files";

export const LABELS = {
  mailbox_full: "Mailbox full", invalid_address: "Address doesn't exist", domain_not_found: "Domain not found",
  blocked_by_receiver: "Blocked by receiver", spam_or_policy: "Spam or policy rejection", temporary: "Temporary problem", other: "Other",
  ok: "Looks normal", spam: "Spam", phishing: "Phishing", malware: "Malware", scam: "Scam", harassment: "Harassment",
  none: "No clear issue", spammy_words: "Pushy sales wording", caps_or_punctuation: "Capitals or !!!", too_many_links: "Too many links",
  deceptive_links: "Hidden or shortened links", image_heavy: "Mostly images", missing_text_version: "No plain-text version",
};
const LABELS_FI = {
  mailbox_full: "Postilaatikko täynnä", invalid_address: "Osoitetta ei ole", domain_not_found: "Verkkotunnusta ei löydy",
  blocked_by_receiver: "Vastaanottaja esti", spam_or_policy: "Hylätty roskapostina", temporary: "Tilapäinen ongelma", other: "Muu",
  ok: "Näyttää normaalilta", spam: "Roskaposti", phishing: "Tietojenkalastelu", malware: "Haittaohjelma", scam: "Huijaus", harassment: "Häirintä",
  none: "Ei selvää ongelmaa", spammy_words: "Tyrkyttävä myyntikieli", caps_or_punctuation: "Isot kirjaimet tai !!!", too_many_links: "Liikaa linkkejä",
  deceptive_links: "Piilotetut tai lyhennetyt linkit", image_heavy: "Lähes pelkkiä kuvia", missing_text_version: "Ei tekstiversiota",
};
export const label = (k) => (localStorage.getItem("cario_lang") === "fi" ? LABELS_FI : LABELS)[k] || LABELS[k] || String(k || "—").replaceAll("_", " ");

const TONES = { low: "border-emerald-500/30 text-emerald-300", medium: "border-amber-500/30 text-amber-300", high: "border-red-500/30 text-red-300", critical: "border-red-500/40 bg-red-500/10 text-red-200" };

const LEVELS_FI = { "very low": "erittäin matala", low: "matala", medium: "keskitaso", high: "korkea", "very high": "erittäin korkea", critical: "kriittinen" };
export const levelText = (t) => (localStorage.getItem("cario_lang") === "fi" && LEVELS_FI[t]) || t;

function askLabel(busy, text, cta, fi) {
  if (busy) return fi ? "Mietitään…" : "Thinking…";
  if (text) return fi ? "Kysy uudelleen" : "Ask again";
  return cta;
}

export function LevelBadge({ level, text, testId }) {
  useT();
  return <span className={`inline-flex whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium ${TONES[level] || "border-white/10 text-zinc-300"}`} data-testid={testId}>{levelText(text || level)}</span>;
}

// Button that streams a Claude answer into a text panel
export function AiText({ path, cta, initial, testId }) {
  const [text, setText] = useState(initial || "");
  const fi = useT().lang === "fi";
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const run = async () => {
    setBusy(true); setError(null); setText("");
    try { await streamPost(text ? `${path}?refresh=true` : path, setText); } catch (e) { setError(e.message); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2" data-testid={testId}>
      <Button type="button" size="sm" variant="outline" onClick={run} disabled={busy} className="border-purple-500/30 bg-purple-500/5 text-purple-100 hover:bg-purple-500/10 hover:text-white" data-testid={`${testId}-button`}>
        <Sparkles className={`mr-1.5 h-3.5 w-3.5 ${busy ? "animate-pulse" : ""}`} />{askLabel(busy, text, cta, fi)}
      </Button>
      {error && <p className="text-xs text-red-300" data-testid={`${testId}-error`}>{error}</p>}
      {text && <div className="whitespace-pre-wrap rounded-lg border border-purple-500/20 bg-purple-950/10 p-3 text-sm leading-relaxed text-zinc-200" data-testid={`${testId}-text`}>{text}</div>}
    </div>
  );
}
